<template>
  <div id="data-list-list-view" class="data-list-container">
    <edit-client
      :isSidebarActive="showSidebar"
      :data="sidebarData"
      @closeSidebar="toggleSidebar"
      :segments="segments"
      :getCustomer="getAllCustomer"
    />
    <import-client
      :isPromptActive="importPrompt"
      @closePrompt="toggleImportPrompt"
      :import-call-back="importCallBack"
    />
    <vs-table ref="table" :max-items="itemsPerPage" search :data="clients">
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <div
          class="flex flex-wrap-reverse items-center data-list-btn-container"
        >
          <div
            class="
              btn-add-new
              p-3
              mb-4
              mr-1
              rounded-lg
              cursor-pointer
              flex
              items-center
              justify-center
              text-lg
              font-medium
              text-base text-primary
              border border-solid border-primary
            "
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary" @click="addNewClient"
              >Nouveau client</span
            >
          </div>

          <div
            class="
              p-3
              mb-4
              mr-4
              rounded-lg
              cursor-pointer
              flex
              items-center
              justify-center
              text-lg
              font-medium
              text-base text-primary
              border border-solid border-primary
            "
          >
            <feather-icon icon="UploadCloudIcon" svgClasses="h-4 w-4" />
            <span
              class="ml-2 text-base text-primary"
              @click="importPrompt = true"
              >Import fichier client</span
            >
          </div>
        </div>
      </div>

      <template slot="thead">
        <vs-th sort-key="name">Raison Social</vs-th>
        <!--<vs-th sort-key="contract">Contrat principal</vs-th>-->
        <vs-th sort-key="status">Etat</vs-th>
        <vs-th sort-key="segment">Segment</vs-th>
        <!--<vs-th sort-key="user">Utilisateur principal</vs-th>-->
        <vs-th sort-key="created_at">Créé le</vs-th>
        <vs-th>Action</vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>{{ tr.social_reason }}</vs-td>
            <!--<vs-td>{{ tr.contract }}</vs-td> -->
            <vs-td>
              <vs-chip :color="tr.status == '1' ? 'success' : 'danger'">
                {{ tr.status == "1" ? "Actif" : "Suspendu" }}
              </vs-chip>
            </vs-td>
            <vs-td>{{ tr.segment.name }}</vs-td>
            <!--<vs-td>{{ tr.mainUser.name }} <span class="text-muted">({{ tr.mainUser.email }})</span></vs-td>-->
            <vs-td>{{ tr.created_at }}</vs-td>
            <vs-td class="whitespace-no-wrap">
              <div class="flex">
                <vx-tooltip :text="tr.status == '1' ? 'Suspendre' : 'Activer'">
                  <feather-icon
                    @click="lock(tr)"
                    :icon="tr.status == '0' ? 'LockIcon' : 'UnlockIcon'"
                    svgClasses="w-5 h-5 hover:text-primary stroke-current"
                    class="mr-2"
                  />
                </vx-tooltip>
                <feather-icon
                  icon="EyeIcon"
                  svgClasses="w-5 h-5 hover:text-primary stroke-current"
                  class="mr-2"
                  @click="goToDetails(tr.id)"
                />
                <vx-tooltip text="Modifier">
                  <feather-icon
                    icon="EditIcon"
                    svgClasses="w-5 h-5 hover:text-primary stroke-current"
                    class="mr-2"
                    @click="edit(tr)"
                  />
                </vx-tooltip>
                <vx-tooltip text="Supprimer">
                  <feather-icon
                    @click="deleteCustomer(tr)"
                    icon="TrashIcon"
                    svgClasses="w-5 h-5 hover:text-primary stroke-current"
                    class="mr-2"
                  />
                </vx-tooltip>
              </div>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <vs-pagination
      v-if="last_page && page"
      :total="last_page"
      v-model="page"
    ></vs-pagination>
  </div>
</template>

<script>
import EditClient from "./EditClient";
import ImportClient from "./ImportClient.vue";
export default {
  components: { EditClient, ImportClient },
  data() {
    return {
      itemsPerPage: 8,
      isMounted: false,
      sidebarData: {},
      showSidebar: false,
      clients: [],
      page: 1,
      last_page: null,
      segments: [],
      importPrompt: false,
    };
  },
  watch: {
    page(value) {
      this.getAllCustomer(value);
    },
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
    queriedItems() {
      return this.$refs.table
        ? this.$refs.table.queriedResults.length
        : this.clients.length;
    },
  },
  mounted() {
    this.isMounted = true;
    this.getAllCustomer(this.page);
  },
  methods: {
    toggleSidebar(val = false) {
      this.showSidebar = val;
    },
    toggleImportPrompt(val = false) {
      console.log(val);
      this.importPrompt = val;
    },
    importCallBack(id) {

      this.toggleImportPrompt();
      setTimeout(() => {
        this.$router.push({ path: "/clients/import-history/" + id });
      }, 400);
    },
    addNewClient() {
      this.sidebarData = {};
      this.getSegment();
      this.toggleSidebar(true);
    },
    edit(data) {
      this.sidebarData = { ...data };
      this.getSegment();
      this.toggleSidebar(true);
    },
    goToDetails(id) {
      this.$router.push("/clients/" + id);
    },
    getAllCustomer(page) {
      this.$vs.loading();
      this.$http
        .get("/customers/list?page=" + page)
        .then((response) => {
          this.clients = response.data.data;
          this.last_page = response.data.last_page;
          this.$vs.loading.close();
        })
        .catch((error) => {
          this.$vs.loading.close();
          if (error.response.status === 401) {
            this.$vs.notify({
              title: "Erreur",
              text: "Votre session a expiré",
              color: "danger",
              iconPack: "feather",
              icon: "icon-check",
              position: "top-right",
            });
            this.$router.push({ name: "login" });
          } else {
            console.log(error);
          }
        });
    },
    lock(tr) {
      if (tr.status == "1") {
        if (confirm("Voullez vous suspendre ce client ?")) {
          this.$vs.loading();
          this.$http
            .post("/customers/lock", { id: tr.id })
            .then((response) => {
              if (response.data.status) {
                this.$vs.loading.close();
                tr.status = "0";
                this.$vs.notify({
                  title: "Succèss",
                  text: "Compte suspendu",
                  color: "success",
                  iconPack: "feather",
                  icon: "icon-check",
                  position: "top-right",
                });
              }
            })
            .catch((error) => {
              this.$vs.loading.close();
              if (error.response.status === 401) {
                this.$vs.notify({
                  title: "Erreur",
                  text: "Votre session a expiré",
                  color: "danger",
                  iconPack: "feather",
                  icon: "icon-check",
                  position: "top-right",
                });
              }
            });
        }
      } else {
        if (confirm("Voullez vous activer ce client ?")) {
          this.$vs.loading();
          this.$http
            .post("/customers/unlock", { id: tr.id })
            .then((response) => {
              if (response.data.status) {
                this.$vs.loading.close();
                tr.status = "1";
                this.$vs.notify({
                  title: "Succèss",
                  text: "Compte activé",
                  color: "success",
                  iconPack: "feather",
                  icon: "icon-check",
                  position: "top-right",
                });
              }
            })
            .catch((error) => {
              this.$vs.loading.close();
              if (error.response.status === 401) {
                this.$vs.notify({
                  title: "Erreur",
                  text: "Votre session a expiré",
                  color: "danger",
                  iconPack: "feather",
                  icon: "icon-check",
                  position: "top-right",
                });
              }
            });
        }
      }
    },
    deleteCustomer(tr) {
      if (confirm("Voullez vous supprimer ce client ?")) {
        this.$vs.loading();
        this.$http
          .post("/customers/delete", { id: tr.id })
          .then((response) => {
            if (response.data.status) {
              this.$vs.loading.close();
              let index = this.clients.indexOf(tr);
              this.clients.splice(index, 1);
              this.$vs.notify({
                title: "Succèss",
                text: "Compte supprimé",
                color: "success",
                iconPack: "feather",
                icon: "icon-check",
                position: "top-right",
              });
            }
          })
          .catch((error) => {
            this.$vs.loading.close();
            if (error.response.status === 401) {
              this.$vs.notify({
                title: "Erreur",
                text: "Votre session a expiré",
                color: "danger",
                iconPack: "feather",
                icon: "icon-check",
                position: "top-right",
              });
            }
          });
      }
    },
    getSegment() {
      this.$vs.loading();
      this.$http
        .get("/segments?paginate=0")
        .then((response) => {
          this.segments = response.data;
          this.$vs.loading.close();
        })
        .catch((error) => {
          this.$vs.loading.close();
          if (error.response.status === 401) {
            this.$vs.notify({
              title: "Erreur",
              text: "Votre session a expiré",
              color: "danger",
              iconPack: "feather",
              icon: "icon-check",
              position: "top-right",
            });
            this.$router.push({ name: "login" });
          } else {
            console.log(error);
          }
        });
    },
  },
};
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 0.5rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
